import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialTypography from "../../../components/MaterialTypography";
import CameraCapture from "./Dualcameracapture";
import {
  createreconcilation,
  createremark,
  updateremark,
} from "./api/mutation";
import { useMutation } from "@apollo/client";
import { useLoading } from "../../../context/LodingContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import { apicall } from "../../../Integration/apicall";
import { allreconcilation, allremarks } from "./api/query";
import URL from "../../../pages/Utils/url";
if (process.env.NODE_ENV !== "production") {
  loadDevMessages();
  loadErrorMessages();
}

const ReconcileDialog = ({ open, onClose, type, data, role }) => {
  const navigate = useNavigate();
  const { userId } = useAuthData();

  const [BeforePhoto, setBeforePhoto] = useState(null);

  const { setCirleLoading } = useLoading();
  const [BeforePhotoFile, setBeforePhotoFile] = useState(null);
  const [isDisabled, setisdiabled] = useState(role == "admin" ? true : false);
  const [AfterPhoto, setAfterPhoto] = useState(null);
  const [createreconcilationnew] = useMutation(createreconcilation);
  const [createremarknew] = useMutation(createremark);
  const [AfterPhotoeFile, setAfterPhotoFile] = useState(null);
  const [fallback, setfallback] = useState(false);
  const [agreedquantity, setagreedquantity] = useState("");
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { value, field } = e;
    setFormData({
      ...formData,
      [field]: value.target.value,
    });
  };

  const handleSubmit = async () => {
    const data =
      type != "remark"
        ? {
            ...formData,
            employeeId: userId,
            actualQuantity: Number(formData.actualQuantity),
            retailPrice: Number(formData.retailPrice),
            imageBefore: BeforePhotoFile,
            imageAfter: AfterPhotoeFile,
          }
        : {
            ...formData,
            agreedProductId: Number(formData.agreedProductId),

            mallEntryId: Number(formData.mallEntryId),
          };

    setCirleLoading(true);

    try {
      const res =
        type != "remark"
          ? await createreconcilationnew({
              variables: {
                input: data,
              },
              context: { hasUpload: true },
            })
          : await createremarknew({
              variables: {
                input: data,
              },
              context: { hasUpload: true },
            });

      const success =
        type != "remark"
          ? res?.data.submitReconciliation?.success
          : res?.data.submitRemark?.success;
      const message =
        type != "remark"
          ? res?.data.submitReconciliation?.message
          : res?.data.submitRemark?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {});
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
    onClose();
  };

  useEffect(() => {
    if (type != "remark") {
      if (role == "admin" && data) {
        fetch_reconcilation_via_agreedprodid_and_mallid(
          data?.id, //agreed prod id
          data?.mallid
        ).then((res) => {
          if (res === undefined) {
            setfallback(true);
            return;
          }
          setfallback(false);
          setFormData({
            // batchExpiry: res?.batchExpiry,
            actualQuantity: res?.actualQuantity,
            batchExpiry: res?.batchExpiry,
            retailPrice: res?.retailPrice,
            remarks: res?.remarks,
          });

          setBeforePhoto(`${URL}media/${res?.imageBefore}`);
          setAfterPhoto(`${URL}media/${res?.imageAfter}`);
        });
      } else {
        setFormData({
          agreedProductId: data?.id,
          // batchExpiry: data?.enddate,
          actualQuantity: "",

          retailPrice: "",
          remarks: "",
        });
      }

      setagreedquantity(data?.quantity);
    } else {
      if (role == "admin" && data) {
        fetch_remarks_via_agreedprodid_and_mallid(data?.id, data?.mallid).then(
          (res) => {
            if (res === undefined) {
              setfallback(true);
              return;
            }
            setfallback(false);
            setFormData({
              text: res?.text,

              remarkid: res?.id,
              approvedStatus: res?.approvedStatus,
            });
          }
        );
      } else {
        setFormData({
          mallEntryId: data?.mallEntryId,
          agreedProductId: data?.id,
          text: "",
          employeeId: userId,
        });
      }
    }
  }, [data, role]);

  const fetch_reconcilation_via_agreedprodid_and_mallid = async (
    agreedprodid = 0,
    mallid = 0
  ) => {
    const res = await apicall(allreconcilation);
    if (res.success) {
      const allreconcile = res?.data?.data?.allReconciliations;

      const filteredreconcile = allreconcile.filter(
        (reconcile) =>
          reconcile.agreedProduct.id == agreedprodid &&
          reconcile.agreedProduct.mallEntry.id == mallid
      );

      const sortedreconcile = filteredreconcile.sort((a, b) => b.id - a.id);

      const recent_reconcile = sortedreconcile[0];
      return recent_reconcile;
    } else {
    }
  };

  const fetch_remarks_via_agreedprodid_and_mallid = async (
    agreedprodid = 0,
    mallid = 0
  ) => {
    const res = await apicall(allremarks);
    if (res.success) {
      const allremarks = res?.data?.data?.allRemarks;

      const filteredremarks = allremarks.filter(
        (remarks) =>
          remarks.agreedProduct.id == agreedprodid &&
          remarks.agreedProduct.mallEntry.id == mallid
      );

      const sortedremarks = filteredremarks.sort((a, b) => b.id - a.id);

      const recent_remarks = sortedremarks[0];
      return recent_remarks;
    } else {
    }
  };

  const handleremarkstatus = async (status) => {
    const data = {
      input: {
        remarkId: formData?.remarkid,
        status,
      },
    };
    const res = await apicall(updateremark, data);

    if (res.success) {
      const success = res.data.data.UpdateRemarkStatus.success;
      const message = res.data.data.UpdateRemarkStatus.message;
      Swal.fire({
        position: "top",
        icon: success ? "success" : "error",
        title: message,
        showConfirmButton: true,
      }).then(() => {
        navigate("/product-compliance");
      });
    } else {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Cannot Approve or Reject Try later",
        showConfirmButton: true,
      }).then(() => {
        navigate("/product-compliance");
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Reconcile Product</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} size={{ xs: 12, md: 12, lg: 12 }}>
          {type != "remark" ? (
            <>
              {fallback === true ? (
                <h3>No Reconcillation Made</h3>
              ) : (
                <>
                  <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Agreed Product Quantity{" "}
                        <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput value={agreedquantity} disabled={true} />
                  </Grid>
                  <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Actual Quantity <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      value={formData.actualQuantity}
                      onChange={(e) =>
                        handleChange({ field: "actualQuantity", value: e })
                      }
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Batch Expiry <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      type="date"
                      value={formData.batchExpiry}
                      onChange={(e) =>
                        handleChange({ field: "batchExpiry", value: e })
                      }
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Retail Price <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      value={formData.retailPrice}
                      onChange={(e) =>
                        handleChange({ field: "retailPrice", value: e })
                      }
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Remarks<span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      value={formData.remarks}
                      onChange={(e) =>
                        handleChange({ field: "remarks", value: e })
                      }
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Grid size={{ xs: 6, md: 6, lg: 6 }}>
                    <MaterialTypography variant="caption" fontWeight="bold">
                      Image Before
                    </MaterialTypography>
                    {role != "admin" ? (
                      <CameraCapture
                        onCapture={(photo) => {
                          setBeforePhoto(photo);
                        }}
                        setCustomerImageFile={(file) =>
                          setBeforePhotoFile(file)
                        }
                      />
                    ) : (
                      <img
                        src={BeforePhoto}
                        alt="Before image"
                        style={{ width: "200px" }}
                      />
                    )}
                  </Grid>
                  <Grid size={{ xs: 6, md: 6, lg: 6 }}>
                    <MaterialTypography variant="caption" fontWeight="bold">
                      Image After
                    </MaterialTypography>
                    {role != "admin" ? (
                      <CameraCapture
                        disabled={!BeforePhoto}
                        onCapture={(photo) => {
                          setAfterPhoto(photo);
                        }}
                        setCustomerImageFile={(file) => setAfterPhotoFile(file)}
                      />
                    ) : (
                      <img
                        src={AfterPhoto}
                        alt="After image"
                        style={{ width: "200px" }}
                      />
                    )}
                  </Grid>
                </>
              )}
            </>
          ) : (
            <Grid size={{ xs: 6, md: 6, lg: 4 }}>
              {fallback === true ? (
                <h3>No Remarks Made</h3>
              ) : (
                <>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Remark<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={formData?.text}
                    multiline
                    rows={4}
                    disabled={isDisabled}
                    onChange={(e) => handleChange({ field: "text", value: e })}
                  />
                </>
              )}
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        {!isDisabled && (
          <>
            <Button onClick={onClose} color="inherit">
              Cancel
            </Button>
            <Button onClick={handleSubmit} color="primary">
              Submit
            </Button>
          </>
        )}
        {formData?.approvedStatus === "pending" && (
          <>
            <Button
              onClick={() => handleremarkstatus("approved")}
              color="primary"
            >
              Approve
            </Button>
            <Button
              onClick={() => handleremarkstatus("rejected")}
              color="primary"
            >
              Reject
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ReconcileDialog;
